import { createRebaseClient } from "@rebasepro/client";

// Configuration from environment
const API_URL = import.meta.env.VITE_API_URL || (import.meta.env.DEV ? "http://localhost:3001" : undefined);

/**
 * Shared Rebase client instance.
 *
 * This is the SAME instance passed to `useRebaseAuthController`, so it carries
 * the authenticated JWT — custom admin views can import it to make authorized
 * data/function calls (token injection + 401 retry handled by the transport).
 */
export const rebaseClient = createRebaseClient({
    baseUrl: API_URL,
});
